"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const underline_1 = __importDefault(require("../../../../components/underline"));
const detectDevice_1 = __importDefault(require("../../../../utils/detectDevice"));
const PerfilStyles_1 = require("../../perfil/PerfilStyles");
require("./ServicesWrapper.scss");
const MOBILE_WIDTH = 992;
const ServicesWrapper = ({ descriptionTitle = '', descriptionText = '', children }) => {
    const { isMobile } = (0, detectDevice_1.default)(MOBILE_WIDTH);
    return (react_1.default.createElement("div", { className: "ServicesWrapper" },
        !isMobile && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PerfilStyles_1.Text, { size: 48 }, "Servi\u00E7os"),
            react_1.default.createElement(underline_1.default, { style: { marginBottom: '30px' } }))),
        react_1.default.createElement("div", { className: "description-container" },
            descriptionTitle &&
                react_1.default.createElement("div", { className: "description-title" }, descriptionTitle),
            descriptionText &&
                react_1.default.createElement("div", { className: "description-text" }, descriptionText)),
        react_1.default.createElement("div", { className: "service-content" }, children)));
};
exports.default = ServicesWrapper;
